import actions from "@/store/modules/my-schedule/actions";
import getters from "@/store/modules/my-schedule/getters";
import mutations from "@/store/modules/my-schedule/mutations";
import state from "@/store/modules/my-schedule/state";

export default {
    actions,
    getters,
    mutations,
    state
}